export { default as RateTableFormComponent } from './rate-table-form';
